import { JSX } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { CallStatusType } from '@/shared/interfaces/call-page.interface';
import { Active } from '../Active/Active';
import { Inbound } from '../Inbound/Inbound';
import { Outbound } from '../Outbound/Outbound';
import { useStore } from '../../stores';
import { observer } from 'mobx-react-lite';
import { CALL_PAGE_TYPE } from '@/shared/constants/callPage';

const fullCall = {
  active: <Active />,
  inbound: <Inbound />,
  outbound: <Outbound />,
  wrapup: <Active />,
} as { [key in CallStatusType]: JSX.Element };

export const CallPage = observer(() => {
  const {
    callStore: { callPage, setCallPage },
  } = useStore();

  const { page, status } = callPage;

  const minimizeCallPage = () => {
    setCallPage({ page: CALL_PAGE_TYPE.MINIMIZED });
  };

  const fullCallComponent = fullCall[status];

  return (
    <div className={`call-page call-page__${page}`}>
      <div className="call-page__switcher">
        {page === 'full' && (
          <div onClick={minimizeCallPage}>
            <span className="call-page__switcher-text">Minimize</span>
            <DownOutlined />
          </div>
        )}
      </div>
      <div className="call-page__main">{fullCallComponent}</div>
    </div>
  );
});
